import InteractiveObject from './InteractiveObject';

const THREE = require('three');
global.THREE = THREE;

require('three/examples/js/loaders/FBXLoader.js');
global.Zlib = require('three/examples/js/libs/inflate.min.js').Zlib;

class Room extends THREE.Object3D {

    constructor({ onClickNote, onClickLongueVue, onClickCale, onClickPerroquet, onLoad }) {
        super();

        this.onLoad = onLoad;

        let scale = 4;
        this.scale.set(scale, scale, scale);

        this.models = [
            {
                path: "Note.fbx",
                ref: "note",
                onClick: onClickNote,
            },
            {
                path: "Cale.fbx",
                ref: "cale",
                onClick: onClickCale,
            },
            {
                path: "Longue_vue.fbx",
                ref: "longueVue",
                onClick: onClickLongueVue,
            },
            {
                path: "Perroquet.fbx",
                ref: "perroquet",
                onClick: onClickPerroquet,
            }
        ];

        let textureLoader = new THREE.TextureLoader();

        // this.lightSwitchTextures = {
        //     on: textureLoader.load('assets/textures/interrupteur_on.jpg'),
        //     off: textureLoader.load('assets/textures/interrupteur_off.jpg'),
        // };
        
        this.state = {
            hidden: false,
        };  

        this.highlightMaterial = new THREE.MeshBasicMaterial({
            color: 0xFF0000
        });

        this.ambientLight = new THREE.AmbientLight(0xf7cedf, 0.1);
        // this.add(this.ambientLight);

        this.interactiveObjects = [];
        
        this.loader = new THREE.FBXLoader();

        this.loaded = 0;
        this.loadCount = 0;

        this.animationMixerObjects = []
        this.objects = []

        this.loadRoom();
        this.loadObjects();
    }
    
    loadRoom() {
        this.loadCount++;

        this.loader.load('assets/models/port_marseille_sd.fbx', (object) => {
            console.log('Room: FBX loaded.');
            console.log(object);

            object.traverse( child => {
                if (child.isMesh) {
                    child.material = new THREE.MeshBasicMaterial( { color: 0xfcebf2, map: child.material.map });
                }
            })
            object.frustumCulled = false

            this.mesh = object;
            this.add(this.mesh);

            this.loaded++;
            this.checkLoad();
        }, () => { }, (error) => {
            console.error(error);
        });
    }

    loadObjects() {
        for (let i = 0; i < this.models.length; i++) {
            const { path, name, onClick, ref, offset } = this.models[i];

            this.loadCount++;

            this.loader.load(`assets/models/${path}`, (object) => {
                if (offset) {
                    object.position.add(offset);
                }

                object.interactable = true;
                this.objects.push(object)

                if (ref) {
                    this[`${ref}`] = object;
                }
                object.traverse( child => {
                    if (child.isMesh) {
                        child.material = new THREE.MeshBasicMaterial( { color: 0xfcebf2, map: child.material.map });
                    }
                })
                    
                this.add(object);

                this.interactiveObjects.push(new InteractiveObject(object, this.highlightMaterial, {
                    onClick,
                }));

                this.loaded++;
                this.checkLoad();

            }, () => { }, (error) => {
                console.error(error);
            });
        }
    }

    checkLoad() {
        if (this.loaded === this.loadCount) {
            if(!this.animationMixer)
                this.animateScene()

            if(this.objects.length > 0)
            {
                this.objects.forEach(object => {
                    this.animateObject(object)
                })

                // this.onLoad();
            }

            this.loadTimer = setInterval( () => {
                let isLoaded = true;
                this.mesh.traverse( child => {
                    if( child.material )
                    {
                        if( !child.material.map.image )
                        {
                            isLoaded = false;
                        }
                    }
                })
                if( isLoaded )
                {
                    clearInterval( this.loadTimer )
                    this.onLoad()
                }
            }, 500)
        }
    }

    toggleLight(enabled) {
        if (this.lightswitch) {
            this.lightswitch.traverse( child => {
                if (child.isMesh && child.name === "Interrupteur_Badgeecran_digit") {
                    child.material.map = enabled ? this.lightSwitchTextures.on : this.lightSwitchTextures.off;
                }
            })
        }
    }

    update(deltaTime) {
        if (this.animationMixer) {
            this.animationMixer.update(deltaTime);
        }
        if (this.animationMixerObjects.length > 0) {
            this.animationMixerObjects.forEach(anim => {
                anim.update(deltaTime)
            })
        }
    }

    animateScene() {
        if (this.mesh) {
            this.animationMixer = new THREE.AnimationMixer(this.mesh);

            let action = this.animationMixer.clipAction(this.mesh.animations[0]);

            // console.log(action, this.animationMixer)
            action.clampWhenFinished = true;
            action.setLoop(THREE.LoopRepeat);
            action.play();

            return true;
        }

        return false;
    }

    animateObject(object) {
        let anim = new THREE.AnimationMixer(object);

        let action = anim.clipAction(object.animations[0]);

        // console.log(action, this.animationMixer)
        action.clampWhenFinished = true;
        action.setLoop(THREE.LoopRepeat);
        action.play();

        this.animationMixerObjects.push( anim )
    }

    hideExcept(object) {
        if (!this.state.hidden) {
            for (let i = 0; i < this.children.length; i++) {
                if (object.id === this.children[i].id) {
                    this.children[i].visible = true;
                } else {
                    this.children[i].visible = false;
                }
            }

            this.state.hidden = true;
        }
    }

    displayAll() {
        if (this.state.hidden) {
            for (let i = 0; i < this.children.length; i++) {
                // if (object.id === this.children[i].id) {
                    this.children[i].visible = true;
                // } else {
                //     this.children[i].visible = false;
                // }
            }

            // this.traverse( child => {
            //     if (child.isMesh) {
            //         child.visible = true;
            //     }
            // });

            this.state.hidden = false;
        }
    }

    dispose() {
        this.traverse( child => {
            if (child.isMesh) {
                child.material.dispose();
                child.geometry.dispose();
            }
            
            child = null;
        });

        if (this.highlightMaterial) {
            this.highlightMaterial.dispose();
            this.highlightMaterial = null;
        }

        this.state = null;
        this.loader = null;
        this.models = null;
    }

}

export default Room;